import styles from './OffCanvasBlock.module.scss';
import Divider from '../Divider/DividerComponent';
import { Fragment, useEffect, useRef, useState, useCallback } from 'react';
import invariant from 'tiny-invariant';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import html2canvas from 'html2canvas';
import { useGetREDLStaticImageUrl } from '../../utils/hooks/useGetFileTreeUrl';
import clsx from 'clsx';

export default function OffCanvasBlockComponent({ block, ultimBloc, goToBlock, removeRenderThumbnail , layoutMetadataPath, renderThumbnails = [] }) {

    const ref = useRef(null);
    const [dragging, setDragging] = useState(false);
    const [thumbnail, setThumbnail] = useState(null);
    const getREDLStaticImageUrl = useGetREDLStaticImageUrl();

    const loadThumbnail = useCallback((remove = false) => {
        const parentElement = document.getElementById(`blocredl-${block.blocIdx}`);
        if (parentElement) {
            const contentElement = parentElement.querySelector(`#blocredl-${block.blocIdx} [class*="bloc-snapshot"]`);
            if (contentElement) {
                setTimeout(() => {
                    html2canvas(contentElement, {
                            logging: false,
                            useCORS: true,
                            backgroundColor: null
                        }).then((canvas) => {
                            setThumbnail(canvas.toDataURL('image/png'));
                            if(remove) removeRenderThumbnail(block.blocIdx);
                        });
                    }, 200);
            }
        }
    }, [block.blocIdx, removeRenderThumbnail]);

    useEffect(() => {
        const el = ref.current;
        invariant(el);
        //loadThumbnail(); ESDPC-166: Deshabilitat temporalment

        return draggable({
            element: el,
            getInitialData: () => ({ blocIdx: block.blocIdx, type: 'thumbnail' }),
            onDragStart: () => setDragging(true),
            onDrop: () => setDragging(false)
        });
    }, [block, loadThumbnail]);

    
    /* ESDPC-166: Deshabilitat temporalment
    if (renderThumbnails.includes(block.blocIdx)) {
        loadThumbnail(true);
    }
    */

    const listItemClass = clsx({
        [styles.redlOffCanvasLayoutListItem]: true,
        [styles.redlOffCanvasLayoutListItemNotEmpty]: layoutMetadataPath
    });

    return (
        <>
            <Divider blocIdx={block.blocIdx} size='sm' />
            <li
                key={block.blocIdx}
                className={listItemClass}
                onClick={goToBlock(block.blocIdx)}
                ref={ref}
            >
            <div className={`${styles.redlOffCanvasLayoutPlaceholder} ${dragging && styles.redlOffCanvasHideBlocStyles}`} 
                style={{
                    backgroundImage: layoutMetadataPath ? `url(${getREDLStaticImageUrl(null, layoutMetadataPath + '.png')})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'top'
                }}
            >
                <span className={styles.redlOffCanvasLayoutNumber}>{block.blocIdx}</span>
                </div>
            </li>
            {ultimBloc === block.blocIdx && <Divider blocIdx={block.blocIdx + 1} size='sm' />}
        </>
    );
}
